import { Outlet } from "react-router-dom";
// import { usePageTitle } from "../hooks/usePageTitle";
import { useMetadata } from '../hooks/useMetadata';
import { useTranslation } from 'react-i18next';

function ServicesLayout() {
    const { i18n } = useTranslation();
    // usePageTitle('Services');
    useMetadata(i18n.language);

    return (
        <Outlet />
    );
}
export default ServicesLayout;